import { LoadingOutlined } from "@ant-design/icons";
import { Modal, Spin } from "antd";
import { memo, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouterProvider, useNavigate } from "react-router-dom";
import "./App.css";
import Alert from "./components/alert/Alert";
import { router } from "./routes";
import { isLogin, getUser, isLogout } from "./Store/Actions/AuthAction";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import { AuthMiddleware } from "./Store/Middlewares/AuthMiddleware";
import {
  declineRinging,
  hideRinging,
  showRinging,
} from "./Store/Actions/GeneralActions";
import { BiSolidPhoneIncoming } from "react-icons/bi";
import { MdCallEnd } from "react-icons/md";
import { TextComponent } from "./components";
import Person from "./assets/staticImages/cplImage1.png";
import Pusher from "pusher-js";
import { VideoCallMiddleware } from "./Store/Middlewares/VideoCallMiddleware";
import { GlobalDebug } from "./utills";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
// GlobalDebug(false,true);

const RouterComponent = memo(() => {
  const loading = useSelector((state) => state.GeneralReducer.loading);
  const antIcon = (
    <LoadingOutlined
      style={{ fontSize: 70, color: "var(--primary-color)" }}
      spin
    />
  );
  return (
    <>
      {loading && (
        <div className="loadingClass">
          <Spin indicator={antIcon} />
        </div>
      )}
      <RouterProvider router={router} />
    </>
  );
});

function App() {
  const dispatch = useDispatch();

  const islogin = useSelector((state) => state.AuthReducer.isLogin);
  const themeColor = useSelector((state) => state.AuthReducer.themeColor);
  const fontFamily = useSelector((state) => state.AuthReducer.fontFamily);
  const showAlert = useSelector((state) => state.GeneralReducer.showAlert);
  const showRinger = useSelector((state) => state.GeneralReducer.showRinging);
  const ringingOptions = useSelector(
    (state) => state.GeneralReducer.ringingOptions
  );

  const ringingchannel = useRef(null);

  useEffect(() => {
    const userData = localStorage.getItem("@user");
    const token = localStorage.getItem("@token");
    var user = JSON.parse(userData && atob(userData));
    // console.log("user", user);
    if (user != null && token != null) {
      dispatch(getUser(user));
      dispatch(isLogin(true));
      dispatch(AuthMiddleware.GeneralType());
      initiateRingingPusher(user);
    } else {
      dispatch(getUser(null));
      dispatch(isLogin(false));
    }
  }, []);

  const initiateRingingPusher = (user) => {
    let pusher = new Pusher("ac81b678f2fe61e8c6eb", { cluster: "mt1" });
    ringingchannel.current = pusher.subscribe(user?.id?.toString());
    ringingchannel.current.bind(
      "App\\Events\\GenerateVideoCallToken",
      (data) => {
        // console.log("GenerateVideoCallToken", data?.data);
        // console.log("ringingOptions", ringingOptions);
        if (data?.data?.message == "Call has been declined") {
          dispatch(
            declineRinging({
              channel_name: data?.data?.channel_name,
              message: data?.data?.message,
            })
          );
        }
        
        else {
          if (data?.data?.caller_id != user?.id) {
            dispatch(
              showRinging({
                caller_id: data?.data?.caller_id,
                caller_image: data?.data?.caller_image
                  ? data?.data?.caller_image
                  : data?.data?.room_image
                  ? data?.data?.room_image
                  : null,
                caller_name: data?.data?.caller_name
                  ? data?.data?.caller_name
                  : data?.data?.room_name
                  ? data?.data?.room_name
                  : "N/A",
                channel_name: data?.data?.channel_name,
                token: data?.data?.token,
                is_group_call: data?.data?.is_group_call,
                receiver_id: data?.data?.receiver_id,
                receiver_name: data?.data?.receiver_name,
                receiver_image: data?.data?.receiver_image,
                room_id: data?.data?.room_id ? data?.data?.room_id : null,
              })
            );
          }
        }
      }
    );
  };

  return (
    <div
      style={{
        "--primary-color": themeColor,
        "--font-family": fontFamily,
        "--shadow-color": `${themeColor}22`,
      }}
    >
      {islogin == null ? (
        <></>
      ) : (
        <>
          {showAlert && <Alert />}
          <RouterComponent />
        </>
      )}
    </div>
  );
}

export default App;
